// delConstants.js
// Holds all constant values for the DEL form and all other DEL attributes

export const DEL_UNIT_TYPES = {
  "all-units": "All Units",
  vehicles: "Vehicles",
  "trailer-tme": "Trailers/TME",
  "field-equipment": "Field/Drilling",
  "industrial-equipment": "Industrial",
  "remediation-equipment": "Remediation",
  ppe: "PPE",
  consumables: "Consumables",
  "oil-spill-equipment": "Oil Spill",
  "pumps-&-hoses": "Pumps/Hoses",
  "small-equipment": "Small",
};

export const DEL_UNIT_TYPE_OPTIONS = Object.entries(DEL_UNIT_TYPES).map(
  ([value, label]) => ({
    value,
    label,
  })
);

export const MISC_QUANTITY_TYPE_OPTIONS = [
  { value: "each", label: "Each" },
  { value: "hours", label: "Hours" },
  { value: "days", label: "Days" },
];

export const RENTAL_QUANTITY_TYPE_OPTIONS = [
  { value: "hours", label: "Hours" },
  { value: "day", label: "Days" }, // Note: keeping as "day" for DB compatibility
];

export const PROJECT_DESCRIPTION_MAX_LENGTH = 250;
